export default __webpack_public_path__ + "static/media/pause.2c713878.svg";